import Num2persian from 'num2persian'
export default {
  methods: {
    Num2persian (inp) {
      return Num2persian(inp)
    },
    async fetchData (method, offset) {
      let o = '?'
      if (method.indexOf('?') > -1) {
        o = '&'
      }
      if (typeof offset === 'undefined') {
        offset = 0
      }
      let data = []
      return new Promise(async (resolve, reject) => {
        while (offset > -1) {
          await this.axios.get(method + (offset > 0 ? o + 'offset=' + offset : ''), {
            headers: {
              Authorization: 'Bearer ' + window.localStorage.getItem('default_auth_token')
            }
          })
            // eslint-disable-next-line no-loop-func
            .then(response => {
              if (typeof response.data.CountAll !== 'undefined') {
                response.data.count_all = response.data.CountAll
                response.data.offset = response.data.Offset
                response.data.limit = response.data.Limit
                response.data.data = response.data.Data
              }
              if (response.data.limit > response.data.data.length) {
                offset = -1
                return resolve(data.concat(response.data.data))
              } else {
                offset += response.data.limit
                data = data.concat(response.data.data)
              }
            })
            // eslint-disable-next-line no-loop-func
            .catch(error => {
              offset = -1
              return reject(error)
            })
        }
      })
    },
    showError (msg) {
      this.$Notice.error({
        title: 'خطایی رخ داده',
        desc: msg
      })
    },
    platePrice (plate, sides, priceList) {
      let prices = priceList.filter(pl => {
        return pl.blank_id === plate.blanks_id && pl.blank_type === plate.blanks_type && pl.blank_size === plate.blanks_size && pl.blank_color === plate.color_id
      })
      prices = prices.sort(function (a, b) {
        return a.to_quantity - b.to_quantity
      })

      if (prices.length === 0) {
        return 0
      }

      let price = 0
      // Get
      prices.forEach(v => {
        // go to biggest
        if (v.to_quantity <= plate.quantity) {
          price = v.price
        }
      })

      if (price === 0) {
        price = prices[0].price
      }
      // add sides prices
      sides.forEach((ps) => {
        if (plate.sides.includes(ps.id)) {
          price += ps.print_price
        }
      })

      if (typeof plate.additional_parameters !== 'undefined' && plate.additional_parameters.length > 0) {
        plate.additional_parameters.forEach(ad => {
          let i = this.additional.find(add => add.ad_id === ad)
          if (typeof i !== 'undefined') {
            price += i.additional_price
          }
        })
      }
      return Math.round(price / 10)
    },
    platePriceWithoutPrint (plate, sides, priceList) {
      let prices = priceList.filter(pl => {
        return pl.blank_id === plate.blanks_id && pl.blank_type === plate.blanks_type && pl.blank_size === plate.blanks_size && pl.blank_color === plate.color_id
      })
      prices = prices.sort(function (a, b) {
        return a.to_quantity - b.to_quantity
      })

      if (prices.length === 0) {
        return 0
      }

      let price = 0
      // Get
      prices.forEach(v => {
        // go to biggest
        if (v.to_quantity <= plate.quantity) {
          price = v.price
        }
      })

      if (price === 0) {
        price = prices[0].price
      }
      if (typeof plate.additional_parameters !== 'undefined' && plate.additional_parameters.length > 0) {
        plate.additional_parameters.forEach(ad => {
          let i = this.additional.find(add => add.ad_id === ad)
          if (typeof i !== 'undefined') {
            price += i.additional_price
          }
        })
      }
      return Math.round(price / 10)
    },
    removeArrayIndex (arr, i) {
      if (this.isEmpty(arr)) {
        return arr
      }
      return arr.splice(1, i).concat(arr.splice(i + 1, arr.length - 1))
    },
    toPersianDigit: function (input, toEnglish) {
      if (typeof input !== 'string') {
        input = input.toString()
      }
      let dg = [
        ['۰', '0'],
        ['۱', '1'],
        ['۲', '2'],
        ['۳', '3'],
        ['۴', '4'],
        ['۵', '5'],
        ['۶', '6'],
        ['۷', '7'],
        ['۸', '8'],
        ['۹', '9']
      ]
      if (typeof toEnglish === 'undefined') {
        toEnglish = false
      }
      if (toEnglish) {
        for (let i = 0; i <= 9; i++) {
          input = input.replace(new RegExp(dg[i][0], 'g'), dg[i][1])
        }
        return input
      }
      for (let i = 0; i <= 9; i++) {
        input = input.replace(new RegExp(dg[i][1], 'g'), dg[i][0])
      }
      return input
    },
    moneyFormat: function (str, ignorePersianChar) {
      if (typeof ignorePersianChar === 'undefined') {
        ignorePersianChar = false
      }
      let minus = ''
      str = parseInt(str, 10)
      if (str < 0) {
        minus = '-'
        str = Math.abs(str)
      }
      let arr = str.toString().split('').reverse()
      let out = []
      let i = 0
      arr.forEach(a => {
        if (i % 3 === 0 && i > 0) {
          out.push('،')
        }
        out.push(a)
        i++
      })
      if (ignorePersianChar) {
        return minus + out.reverse().join('')
      }
      return minus + this.toPersianDigit(out.reverse().join(''), false)
    },
    isEmpty (obj) {
      for (let prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          return false
        }
      }
      return JSON.stringify(obj) === JSON.stringify({})
    }
  }
}



// WEBPACK FOOTER //
// ./src/globals.js